import script from "./ContactInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./ContactInfoModal.vue?vue&type=style&index=0&id=6ffd2b8d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffd2b8d"]])

export default __exports__